
import { t } from 'i18next';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import DataGrid, { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import React, { useCallback, useRef, useState } from 'react';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';
import { productRecipeService } from '../services/product-recipe-service';
import { productPortfolioService } from '../services/product-portfolio-service';
import { toast } from 'react-toastify';
import { confirm } from 'devextreme/ui/dialog';
import CustomStore from 'devextreme/data/custom_store';

const ProductRecipeSubList = (props: DataGridTypes.MasterDetailTemplateData) => {

    const [productRecipe] = useState<any>(
        {
            receiptProductCode: null, recipeDetails: null
        }
    );

    const dataGridDetailRef = useRef<DataGrid>(null);
    const { receiptProductCode } = props.data.data;

    const [detailStore] = useState(() => createCustomStore({
        key: 'receiptProductCode',
        load: productRecipeService.getOrderDetailList,
        
        onLoading(loadOptions) { 
            if (receiptProductCode) {
                loadOptions.filter = [["ReceiptProductCode", "=", receiptProductCode]];
            }
        },
    }));



    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onSave = async () => {
        if (dataGridDetailRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridDetailRef.current?.instance.saveEditData();
                }
            });
        }
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            productRecipe.receiptProductCode = receiptProductCode;
            productRecipe.recipeDetails = e.changes;
            productRecipeService.saveee(productRecipe).then((response) => {
                dataGridDetailRef.current?.instance.refresh().then(x => dataGridDetailRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }

    return (

        <React.Fragment>
            <DataGridWrapper
                props={{ ref: dataGridDetailRef }}
                datasource={detailStore}
                remoteOperations={false}
                showColumnLines={true}
                columnChooser={false}
                pagerVisible={true}
                filterVisible={false}
                headerFilterVisible={true}
                keyboardNavigation={true}
                excellExport={false}
                onSaving={onSaving}
                onFocusedCellChanging={onFocusedCellChanging}
                onRowUpdating={handleRowUpdating}
                editingConfig={{
                    mode: "popup",
                    useIcons: true,
                    allowAdding: false,
                    allowDeleting: false,
                    allowUpdating: false,
                }}
                columns={[
                    {
                        dataField: 'vendorCode',
                        caption: t('syncflow:lb_vendor_code'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                        visible:false,
                    },
                     {
                        dataField: 'vendorName',
                        caption: t('syncflow:lb_vendor_name'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                    },
                    {
                        dataField: 'productCode',
                        caption: t('syncflow:lb_product_code'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                        visible:false,
                    },
                    {
                        dataField: 'productName',
                        caption: t('syncflow:lb_product_name'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                    },
                    {
                        dataField: 'productQty',
                        caption: t('syncflow:lb_qty'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                    },
                    {
                        dataField: 'productUnitCode',
                        caption: t('syncflow:lb_measurement_unit_code'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                    },
                    {
                        dataField: 'costPrice',
                        caption: "Cost Price",
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                        format: { style: "currency", currency: "USD", useGrouping: true }
                    },
                    {
                        dataField: 'costAmaount',
                        caption: "Cost Amount",
                        filtering: false,
                        allowSearch: false,
                        allowEditing: true,
                        format: { style: "currency", currency: "USD", useGrouping: true }
                    }
                ]}
            />
        </React.Fragment>
    )
}
export default ProductRecipeSubList